import React from 'react'
import { shallow } from 'enzyme'

import EditorTitle from '../../features/TextEditor/EditorTitle'
import CloseIcon from '../../../common/icons/CloseIcon2'

describe('EditorTitle', () => {
  let wrapper, props, result, instance
  beforeEach(() => {
    props = {
      title: 'Editor Title',
      onCloseClick: jest.fn(),
    },
    wrapper = shallow(<EditorTitle {...props} />)
    instance = wrapper.instance()
  })
  it('should have close Icon by default', () => {
    const closeIcon = wrapper.find(CloseIcon).at(0)
    expect(closeIcon).toHaveLength(1)
  })
  it('should have title by default', () => {
    const title = wrapper.find('EditorTitle__TitleText').at(0)
    expect(title).toHaveLength(1)
    expect(title.childAt(0).text()).toBe(props.title)
  })
  describe('#render', () => {
    describe('when close button is clicked', () => {
      it('should call props onCloseClick method', () => {
        const closeIcon = wrapper.find('EditorTitle__ClickableIcon').at(0)
        closeIcon.simulate('click')
        expect(props.onCloseClick).toHaveBeenCalledTimes(1)
      })
    })
  })

})